import { createTheme } from '@mui/material/styles';

import layout from './layout';
import palette from './palette';
import typography from './typography';

type LayoutConfig = typeof layout;

declare module '@mui/material/styles' {
  interface Theme {
    layout: LayoutConfig;
  }
  interface ThemeOptions {
    layout?: LayoutConfig;
  }
  interface Palette {
    blue: Record<number | string, string>;
  }
  interface PaletteOptions {
    blue?: Record<number | string, string>;
  }
}

const baseTheme = createTheme({
  palette,
  typography,
  layout,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440,
    },
  },
});

export default baseTheme;
